const intialState = {
  deliveryInformation: {
    FirstName: '',
    Surname: '',
    ContactNumber: '',
    Email: '',
    PreferredDeliveryDay: '',
    PreferredDeliveryTimes: '',
  },
  backorderNotification: {
    sameAsDelivery: false,
    FirstName: '',
    Surname: '',
    ContactNumber: '',
    Email: '',
  },
  featureDeals: {
    sameAsDelivery: false,
    FirstName: '',
    Surname: '',
    ContactNumber: '',
    Email: '',
  },
  accountPayable: {
    sameAsDelivery: false,
    FirstName: '',
    Surname: '',
    ContactNumber: '',
    Email: '',
  },
}

const MyAccountReducer = function (state = intialState, action) {
  switch (action.type) {
    case 'UPDATE_DELIVERY_INFO_FIELDS': {
      return {
        ...state,
        deliveryInformation: {
          ...state.deliveryInformation,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_BACKORDER_NOTIFICATION_FIELDS': {
      return {
        ...state,
        backorderNotification: {
          ...state.backorderNotification,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_FEATURES_DEALS_FIELDS': {
      return {
        ...state,
        featureDeals: {
          ...state.featureDeals,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_ACCOUNT_PAYABLE_FIELDS': {
      return {
        ...state,
        accountPayable: {
          ...state.accountPayable,
          [action.key]: action.value,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default MyAccountReducer
